import React from "react";
import PropTypes from "prop-types";
import { formViews } from "../../common/AccountForm";
import "./PreviousFundraiserMessage.scss";

const PreviousFundraiserMessage = ({
    formView,
    lastEventName,
    isPreviousFundraiser,
    hasLoggedInToThisEventBefore,
}) => {
    // Only render the previous fundraiser message if the log in form is
    // visible, the fundraiser is a previous fundraiser and it is their first
    // time logging into this event
    if (
        formView === formViews.SIGN_IN &&
        isPreviousFundraiser &&
        !hasLoggedInToThisEventBefore
    ) {
        return (
            <div className="previous-fundraiser-message grid">
                <div className="col col--12">
                    <div className="previous-fundraiser-message__container">
                        <small>
                            You’ve participated in a previous fundraiser powered
                            by Qgiv <strong>({lastEventName})</strong>.
                        </small>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

PreviousFundraiserMessage.propTypes = {
    formView: PropTypes.string.isRequired,
    lastEventName: PropTypes.string.isRequired,
    isPreviousFundraiser: PropTypes.bool.isRequired,
    hasLoggedInToThisEventBefore: PropTypes.bool.isRequired,
};

export default PreviousFundraiserMessage;
